<template>
  <FullModal ref="modal" class="ProfileModal" @close="close">
    <div slot="title" class="title">
      프로필 설정
    </div>
    <div slot="content" class="content" style="margin-top: 2vh; margin-bottom: 2vh">
      <div class="info">
        <div class="left">
          <div class="label">개업 연도</div>
          <div class="select">
            <select v-model="data.startdate" :class="{'active':data.startdate}">
              <option :value="null" disabled>선택</option>
              <option :key="thisYear+1-year"
                      :value="thisYear+1-year+'-01-01'"
                      v-for="year in 200">
                {{thisYear+1-year}}</option>
            </select>
          </div>
        </div>
        <div class="right">
          <div class="label">업종</div>
          <div class="select">
            <select v-model="data.category" :class="{'active':data.category}">
              <option :value="null" disabled>선택</option>
              <option :key="index"
                      :value="category"
                      v-for="(category, index) in categories">
                {{category}}</option>
            </select>
          </div>
        </div>
        <div class="bottom">
            <div class="input">
              <ValidationProvider name="nickname" rules="required|nickname" v-slot="{ valid, errors }" ref="validInput">
                  <input type="text" @keyup="validateInput(valid, $event)" v-model="data.nickname" :maxlength="8"
                         placeholder="닉네임을 설정해 주세요."/>
                  <span class="error-text">{{ errors[0] || errors.nickname }}</span>
              </ValidationProvider>
            </div>
        </div>
      </div>
      <div class="profile">
        <div class="label">캐릭터 선택</div>
        <div class="items">
          <button class="item" :key="index" v-for="(profile, index) in profiles"
                  @click="clickProfile(profile)"
                  :class="{'active': profile.title == data.image_nowtalk}">
            <img :src="profile.image"/>
          </button>
        </div>
      </div>
    </div>
    <div slot="buttons" class="buttons">
      <button @click="complete"
              :class="{'active':canComplete}">
        설정 완료
      </button>
    </div>
  </FullModal>
</template>

<script>
// Services
import AuthService from '@/service/auth/AuthService'

// Api
import userApi from '@/api/now/userApi'

// Components
import FullModal from '@/components/modal/FullModal'

export default {
  name: 'ProfileModal',
  components: {
    FullModal,
  },
  chimera: {
    patchUser() { return { url: `/users/${AuthService.getProfile().uuid}/`, method: 'PATCH', params: this.data } },
  },
  data: function () {
    let getImage = function (title) {
      return require('@/assets/images/talk/profile/' + title + '.png')
    }
    return {
      isValid: false,
      data: {
        startdate: null,
        image_nowtalk: null,
        category: null,
        nickname: null
      },
      categories: ['한식', '중식', '일식', '양식', '아시안', '분식', '치킨', '카페', '기타'],
      profiles: [
        { title: 'lion', image: getImage('lion') },
        { title: 'dog', image: getImage('dog') },
        { title: 'deer', image: getImage('deer') },
        { title: 'pig', image: getImage('pig') },
        { title: 'rabbit', image: getImage('rabbit') },
        { title: 'chicken', image: getImage('chicken') },
        { title: 'fox', image: getImage('fox') },
        { title: 'mouse', image: getImage('mouse') },
        { title: 'llama', image: getImage('llama') },
        { title: 'raccoon', image: getImage('raccoon') },
        { title: 'tiger', image: getImage('tiger') },
        { title: 'sheep', image: getImage('sheep') },
      ]
    }
  },
  computed: {
    thisYear() {
      let today = new Date()
      return today.getFullYear()
    },
    canComplete() {
      if (this.data.startdate && this.data.category && this.data.nickname && this.data.image_nowtalk && this.isValid) {
        return true
      }
      return false
    }
  },
  async created() {
    this.setData()
  },
  methods: {
    async validateInput(valid, $event) {
      let inputValue = $event.target.value
      let { data } = await userApi.getNickname({ nickname: inputValue })
      if (inputValue.length > 1) {
        valid = true
      }
      if (data.is_exists) {
        this.$refs.validInput.setErrors({
          nickname: '이미 등록되어 있는 닉네임입니다.'
        })
        valid = false
      }
      this.isValid = valid
    },
    setData() {
      let user = AuthService.getProfile()
      if (user) {
        if (user.category) {
          this.data.category = user.category
        }
        if (user.startdate) {
          this.data.startdate = user.startdate.slice(0, 4) + '-01-01'
        }
        if (user.nickname) {
          this.data.nickname = user.nickname
        }
        if (user.image_nowtalk) {
          this.data.image_nowtalk = user.image_nowtalk
        }
      }
    },
    clickProfile(profile) {
      this.data.image_nowtalk = profile.title
    },
    async complete() {
      if (this.canComplete) {
        await this.patchUser.fetch()
        await AuthService.syncProfile()
        this.$emit('complete')
      }
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
  .ProfileModal {
    display: block;
    float: left;
    position: fixed;
    bottom: 0;
    overflow-y: auto;
    .title {
      font-weight: 900;
      font-size: 18px;
      text-align: center;
      padding: 0 25px;
      margin-top: 3.5vh;
      padding: 0 11.5vw;
    }
    .content {
      width: 100%;
      max-height: calc(434% / 667 * 100);
      overflow: scroll;
      padding: 0 11.5vw;
      .info {
        width: 100%;
        float: left;
        display: block;
        .left {
          float: left;
          width: calc(50% - 5.5px);
        }
        .right {
          float: right;
          width: calc(50% - 5.5px);
        }
        .bottom {
          width: 100%;
          margin-top: 1.5vh;
          .input {
            width: 100%;
            span {
              width: 100%;
            }
            .error-text {
              text-align: left;
              font-size: 12px;
              line-height: 1.83;
              letter-spacing: -0.26px;
              margin-top: 4px;
              color: #ff1616;
            }
            input {
              width: 100%;
              border-radius: 4px;
              border: solid 1px #d7e1ea;
              font-size: 16px;
              height: 6.6vh;
            }
          }
        }
        .label {
          float: left;
          width: 100%;
          font-weight: 900;
          font-size: 15px;
          text-align: left;
        }
        .select {
          width: 100%;
          float: left;
          margin-top: 1.2vh;
          select {
            height: 6.6vh;
            float: left;
            width: 100%;
            border-radius: 4px;
            border: solid 1px #d7e1ea;
            text-align-last: left;
            padding-left: 12px;
            font-weight: 700;
            font-size: 17px;
            line-height: 1;
            color: #333333;
            background: url('../../../assets/icon/down.svg') right 12px center no-repeat;
            option {
              direction: ltr;
            }
            &:not(.active) {
              color: #9aa4b3;
            }
          }
        }
      }
      .profile {
        float: left;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-top: 2.4vh;
        .label {
          width: 100%;
          text-align: left;
          font-size: 15px;
          font-weight: 900;
          margin-bottom: 7px;
        }
        .items {
          width: 100%;
          .item {
            display: block;
            width: calc(100% / 3);
            float: left;
            background: none;
            margin-bottom: 12px;
            img {
              height: 100%;
              border-radius: 100%;
              @media screen and (max-width: 350px) {
                width: 62px;
                height: 62px;
              }
              @media screen and (min-width: 350px) {
                width: 72px;
                height: 72px;
              }
            }
            &:nth-child(3n+1) { img { display: block; float: left; } }
            &:nth-child(3n+2) { img { display: block; float: none; margin: auto; } }
            &:nth-child(3n+0) { img { display: block; float: right; } }
            &.active {
              img {
                border-width: 2px;
                border-color: #1baaf1;
              }
            }
          }
        }
      }
    }
    .buttons {
      button {
        width: 100%;
        color: #9aa4b3;
        background-color: white;
        &.active {
          color: white;
          background-color: #333333;
        }
      }
    }
  }
</style>
